import { render } from "./form.vue?vue&type=template&id=7780a65c&scoped=true&ts=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=7780a65c&scoped=true&lang=less"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7780a65c"]])

export default __exports__